import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "task-center"
};
const _hoisted_2 = {
  class: "task-header"
};
const _hoisted_3 = {
  class: "task-grid"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "preview-container"
};
const _hoisted_6 = {
  class: "train-main"
};
const _hoisted_7 = {
  class: "media-container"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "preview-controls"
};
const _hoisted_10 = {
  class: "preview-counter"
};
const _hoisted_11 = {
  class: "action-buttons"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};
const _hoisted_13 = {
  class: "membership-box my-scroller"
};
import TaskCenterCard from './components/taskCenterCard.vue';
import { ref, computed, onUnmounted, watch, onMounted, nextTick } from 'vue';
import { MediaType, customMakeStatus, ext, customCancel, customConfirmMake, hasMakeType, getAppTencentCustomMake } from '@/request/customrize';
import { useUserPackResource, useAppTencentCustomMakePage } from './useTaskCenter';
import { ArrowLeft, ArrowRight, CircleCloseFilled } from '@element-plus/icons-vue';
import custPhotoMan from './components/custPhotoMan.vue';
import custVirtualMan from './components/custVirtualMan.vue';
import custTimbre from './components/custTimbre.vue';
import custStandardMan from './components/custStandardMan.vue';
import custFlexusMan from './components/custFlexusMan.vue';
import { PollingTimer } from '@/utils/pollingTimer';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { useAudioPlayer } from '@/hooks/useAudioPlayer';
import membershipHub from '@/views/userCenter/membershipHub';
import { useRouter, useRoute } from 'vue-router';
const imgTeachVideoSrc = 'https://client-file.lzwcdm.com/ai-virtual-man/30929022f21449aa2927e3051ee8fe37/20250212/643845749325829.mp4';
const allTeachVideoSrc = 'https://client-file.lzwcdm.com/ai-virtual-man/30929022f21449aa2927e3051ee8fe37/20250212/643845596934149.mp4';
// const imgTeachVideoSrc = require('@/assets/data/照片数字人视频制作参考.mp4')
// const allTeachVideoSrc = require('@/assets/data/拍摄指引视频精简-丐版.mp4')
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const {
      isPlaying,
      toggle,
      setVolume,
      pause
    } = useAudioPlayer();
    const popoverVisible = ref(false);
    const {
      szrPackages: originalPackages,
      fetchUserResource
    } = useUserPackResource();
    const tab = ref('IMAGE_PHOTO');
    const szrPackages = computed(() => {
      var _originalPackages$val;
      return (_originalPackages$val = originalPackages.value) === null || _originalPackages$val === void 0 ? void 0 : _originalPackages$val.filter(item => !['SELF_PHOTO_VIDEO', 'SELF_VIRTUAL_MAN'].includes(item.makeType));
    });
    const szrPackagesItem = computed(() => szrPackages.value.find(({
      makeType
    }) => makeType === tab.value) || {
      usableCount: 0
    });
    onMounted(() => {
      var _route$query, _route$query2, _route$query3;
      nextTick(() => {
        fetchUserResource();
      });
      if ((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.buyTpye && hasMakeType((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.buyTpye)) {
        buyTpye.value = route.query.buyTpye;
      }
      console.log(route.query, szrPackages.value, 'route.query');
      if ((_route$query3 = route.query) !== null && _route$query3 !== void 0 && _route$query3.tab) {
        var _route$query4;
        tab.value = ((_route$query4 = route.query) === null || _route$query4 === void 0 ? void 0 : _route$query4.tab) || 'IMAGE_PHOTO';
      }
    });
    const buyTpye = ref('main');
    const direction = ref('horizontal');
    const fillRatio = ref(30);
    let {
      customMakeArr,
      fetchCustomMakePage
    } = useAppTencentCustomMakePage();
    let pollingTimer = null;
    const updateData = async () => {
      const stopPolling = await fetchCustomMakePage({
        makeTypes: [tab.value]
      });
      return !stopPolling;
    };
    pollingTimer = new PollingTimer(updateData, 5000);
    pollingTimer.start();
    watch(() => tab.value, makeTypes => {
      var _pollingTimer;
      (_pollingTimer = pollingTimer) === null || _pollingTimer === void 0 || _pollingTimer.cancel();
      pollingTimer = new PollingTimer(updateData, 5000);
      pollingTimer.start();
    });
    watch(() => buyTpye.value, makeTypes => {
      console.log('makeTypesmakeTypes', makeTypes);
      fetchUserResource();
    });
    onUnmounted(() => {
      var _pollingTimer2;
      (_pollingTimer2 = pollingTimer) === null || _pollingTimer2 === void 0 || _pollingTimer2.cancel();
    });
    // 查看训练结果
    let showTrain = ref(false);
    let demoInfo = ref([]);
    let getMediaType = url => {
      return MediaType.get(`.${ext(url)}`) || null;
    };
    // 预览相关状态
    const currentPreviewIndex = ref(0);
    const currentPreviewUrl = computed(() => demoInfo.value[currentPreviewIndex.value]);
    // 预览控制方法
    const prevPreview = () => {
      if (currentPreviewIndex.value > 0) {
        currentPreviewIndex.value--;
      }
    };
    const nextPreview = () => {
      if (currentPreviewIndex.value < demoInfo.value.length - 1) {
        currentPreviewIndex.value++;
      }
    };
    // 当对框关闭时重置预览索引
    watch(showTrain, newVal => {
      if (!newVal) {
        currentPreviewIndex.value = 0;
      }
    });
    const trainingData = ref(undefined);
    let clickItem = i => {
      demoInfo.value = JSON.parse(i.demoInfo);
      trainingData.value = i;
      showTrain.value = true;
    };
    // 重新上上传
    let clickItemEdit = i => {
      getAppTencentCustomMake(i.id).then(res => {
        var _data$demoDriveType;
        let {
          code,
          data
        } = res.data;
        trainingData.value = {
          ...data,
          ...(data === null || data === void 0 ? void 0 : data.timbreTemplate),
          demoDriveType: !(data !== null && data !== void 0 && (_data$demoDriveType = data.demoDriveType) !== null && _data$demoDriveType !== void 0 && _data$demoDriveType.length) ? [] : data === null || data === void 0 ? void 0 : data.demoDriveType
        };
        buyTpye.value = data.makeType;
      });
    };
    // 使用
    const VERSION_PATHS = {
      100: '/design/',
      200: '/video-design/'
    };
    let clickItemUse = i => {
      const basePath = '/design/';
      window.location.href = window.origin + `${basePath}#/`;
    };
    // 取消任务
    let goCustomCancel = i => {
      ElMessageBox.confirm('确定要取消任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        customCancel(i.id).then(res => {
          let {
            code,
            data
          } = res.data;
          if (code === 200) {
            ElMessage.success('取消成功');
            fetchCustomMakePage({
              makeTypes: [tab.value]
            });
            fetchUserResource(); // 添加更新用户资源
          }
        });
      });
    };
    // 确认制作
    function customConfirmMakeFn(operate) {
      if (!trainingData.value) return;
      const params = {
        makeId: trainingData.value.id,
        reason: '',
        operate
      };
      if (operate === 'REJECT') {
        ElMessageBox.prompt('请输入驳回原因', '驳回原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^.{1,300}$/,
          inputErrorMessage: '驳回原因不能为空且最多300个字符'
        }).then(({
          value
        }) => {
          var _params$reason;
          params.reason = value.trim();
          if (!((_params$reason = params.reason) !== null && _params$reason !== void 0 && _params$reason.length)) {
            ElMessage.error('原因不能为空');
            return;
          }
          customConfirmMake(params).then(() => {
            showTrain.value = false;
            ElMessage.success('操作成功');
            fetchUserResource(); // 添加更新用户资源
          });
        });
      } else {
        customConfirmMake(params).then(() => {
          showTrain.value = false;
          ElMessage.success('操作成功');
          fetchUserResource(); // 添加更新用户资源
        });
      }
    }
    // let customConfirmMakeFn = (type) => {
    //   customConfirmMake({
    //     id: trainingData.value.id,
    //     status: type
    //   }).then(res => {
    //     let { code, data } = res.data
    //     if (code === 200) {
    //       ElMessage.success('操作成功')
    //       showTrain.value = false
    //       fetchCustomMakePage({ makeTypes: [tab.value] })
    //     }
    //   })
    // }
    const membershipHubShow = ref(false);
    const handlePaymentStatusChange = status => {
      fetchUserResource();
    };
    const handleSubmitSuccess = () => {
      buyTpye.value = 'main';
      fetchUserResource();
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_image = _resolveComponent("el-image");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [buyTpye.value === 'main' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 21
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.value = $event),
            placeholder: "定制任务项",
            class: "task-select"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(szrPackages.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.makeType
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            class: "add-btn",
            onClick: _cache[1] || (_cache[1] = $event => !szrPackagesItem.value.usableCount ? membershipHubShow.value = true : [trainingData.value, buyTpye.value] = [null, tab.value])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(szrPackagesItem.value.usableCount ? `可定制数量：${szrPackagesItem.value.usableCount}` : '添加定制'), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _unref(customMakeArr).length ? (_openBlock(), _createBlock(_component_el_scrollbar, {
        key: 0,
        class: "task-grid-scroll"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customMakeArr), item => {
          return _openBlock(), _createBlock(TaskCenterCard, {
            key: item.id,
            item: item,
            "is-playing": _unref(isPlaying),
            "current-item": trainingData.value,
            "custom-make-status": _unref(customMakeStatus),
            onPlay: _cache[2] || (_cache[2] = i => (trainingData.value = i, _unref(toggle)(i.audioUrl))),
            onCancel: _unref(goCustomCancel),
            onUse: _unref(clickItemUse),
            onEdit: _unref(clickItemEdit),
            onView: _cache[3] || (_cache[3] = i => (_unref(pause)(), _unref(clickItem)(i)))
          }, null, 8, ["item", "is-playing", "current-item", "custom-make-status", "onCancel", "onUse", "onEdit"]);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true), !_unref(customMakeArr).length ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "margin-top": "50px"
        },
        description: "快来定制吧！"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => !szrPackagesItem.value.usableCount ? membershipHubShow.value = true : [trainingData.value, buyTpye.value] = [null, tab.value])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(szrPackagesItem.value.usableCount ? `可定制数量：${szrPackagesItem.value.usableCount}` : '添加定制'), 1)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), buyTpye.value !== 'main' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 21
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            icon: _unref(ArrowLeft),
            type: "text",
            onClick: _cache[5] || (_cache[5] = $event => buyTpye.value = 'main'),
            style: {
              "font-weight": "bold"
            }
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("返回任务中心")])),
            _: 1
          }, 8, ["icon"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createVNode(_component_el_popover, {
            effect: "dark",
            trigger: "click",
            visible: popoverVisible.value,
            "onUpdate:visible": _cache[6] || (_cache[6] = $event => popoverVisible.value = $event),
            placement: "bottom",
            title: "了解拍摄明细",
            width: 450
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("看视频了解定制拍摄明细")])),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("video", {
              src: buyTpye.value === 'IMAGE_PHOTO' ? imgTeachVideoSrc : allTeachVideoSrc,
              style: {
                "width": "100%"
              },
              controls: "true"
            }, null, 8, _hoisted_4)]),
            _: 1
          }, 8, ["visible"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_divider, {
        style: {
          "margin": "15px 0"
        }
      }), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24,
          style: {
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
          }
        }, {
          default: _withCtx(() => [buyTpye.value === 'IMAGE_PHOTO' ? (_openBlock(), _createBlock(custPhotoMan, {
            key: 0,
            setTrainingData: trainingData.value,
            onSubmitSuccess: handleSubmitSuccess
          }, null, 8, ["setTrainingData"])) : _createCommentVNode("", true), buyTpye.value === 'IMAGE_GENERAL' ? (_openBlock(), _createBlock(custVirtualMan, {
            key: 1,
            setTrainingData: trainingData.value,
            onSubmitSuccess: handleSubmitSuccess
          }, null, 8, ["setTrainingData"])) : _createCommentVNode("", true), buyTpye.value === 'SELF_VIRTUAL_MAN' ? (_openBlock(), _createBlock(custStandardMan, {
            key: 2,
            setTrainingData: trainingData.value,
            onSubmitSuccess: handleSubmitSuccess
          }, null, 8, ["setTrainingData"])) : _createCommentVNode("", true), buyTpye.value === 'VOICE_TTS' ? (_openBlock(), _createBlock(custTimbre, {
            key: 3,
            setTrainingData: trainingData.value,
            onSubmitSuccess: handleSubmitSuccess
          }, null, 8, ["setTrainingData"])) : _createCommentVNode("", true), buyTpye.value === 'FLEXUS_MAN' ? (_openBlock(), _createBlock(custFlexusMan, {
            key: 4,
            setTrainingData: trainingData.value,
            onSubmitSuccess: handleSubmitSuccess
          }, null, 8, ["setTrainingData"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _unref(showTrain),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(showTrain) ? showTrain.value = $event : showTrain = $event),
        "close-on-click-modal": false,
        title: "查看训练结果",
        top: "6vh",
        center: "",
        width: "55%",
        class: "train-dialog"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(getMediaType)(currentPreviewUrl.value) === 'IMAGES' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          style: {
            "width": "100%",
            "height": "100%"
          },
          fit: "contain",
          src: currentPreviewUrl.value,
          class: "preview-media"
        }, null, 8, ["src"])) : _createCommentVNode("", true), _unref(getMediaType)(currentPreviewUrl.value) === 'AUDIOS' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 1,
          onClick: _cache[7] || (_cache[7] = $event => _unref(toggle)(currentPreviewUrl.value)),
          src: require('@/assets/images/FadLogoAudiobus.png'),
          fit: "contain",
          class: "preview-media audio-preview"
        }, null, 8, ["src"])) : _createCommentVNode("", true), _unref(getMediaType)(currentPreviewUrl.value) === 'AUDIOS' ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: {
            "position": "absolute"
          },
          onClick: _cache[8] || (_cache[8] = $event => _unref(toggle)(currentPreviewUrl.value))
        }, [_createVNode(_component_svgIcon, {
          iconClass: _unref(isPlaying) ? 'pusewhite' : 'play',
          width: "60px",
          height: "60px"
        }, null, 8, ["iconClass"])])) : _createCommentVNode("", true), _unref(getMediaType)(currentPreviewUrl.value) === 'VIDEOS' && currentPreviewUrl.value ? (_openBlock(), _createElementBlock("video", {
          key: 3,
          src: currentPreviewUrl.value,
          class: "preview-media video-preview",
          controls: ""
        }, null, 8, _hoisted_8)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: prevPreview,
          disabled: currentPreviewIndex.value <= 0,
          class: "control-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            style: {
              "margin-right": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
            _: 1
          }), _cache[16] || (_cache[16] = _createTextVNode(" 上一个 "))]),
          _: 1
        }, 8, ["disabled"]), _createElementVNode("div", _hoisted_10, _toDisplayString(currentPreviewIndex.value + 1) + "/" + _toDisplayString(_unref(demoInfo).length), 1), _createVNode(_component_el_button, {
          type: "primary",
          onClick: nextPreview,
          disabled: currentPreviewIndex.value >= _unref(demoInfo).length - 1,
          class: "control-btn"
        }, {
          default: _withCtx(() => [_cache[17] || (_cache[17] = _createTextVNode(" 下一个 ")), _createVNode(_component_el_icon, {
            style: {
              "margin-left": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          type: "danger",
          size: "large",
          plain: "",
          onClick: _cache[9] || (_cache[9] = $event => customConfirmMakeFn('REJECT'))
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("不满意")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "success",
          size: "large",
          onClick: _cache[10] || (_cache[10] = $event => customConfirmMakeFn('AGREE'))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("满意")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: membershipHubShow.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => membershipHubShow.value = $event),
        top: "6vh",
        center: "",
        width: "85%",
        "show-close": false,
        "close-on-click-modal": false,
        class: "membership-dialog"
      }, {
        header: _withCtx(({
          close,
          titleId,
          titleClass
        }) => [_createElementVNode("div", _hoisted_12, [_cache[21] || (_cache[21] = _createElementVNode("h4", {
          style: {
            "margin": "0",
            "color": "#5b54f9"
          }
        }, "想要拥有更多实用功能吗？快来获取吧！", -1)), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[12] || (_cache[12] = $event => membershipHubShow.value = false)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
            _: 1
          }), _cache[20] || (_cache[20] = _createTextVNode(" 关闭 "))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_unref(membershipHub), {
          onPaymentStatusChange: handlePaymentStatusChange
        })])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});